export default function () {
  return {
    all: [],
    single: null,
  };
}
